import React, { useEffect } from "react";
import "./ModalMessage.css";

interface ModalMessageProps {
  title: string;
  description: string;
  leftButtonText: string;
  leftButtonAction: () => void;
  rightButtonText: string;
  rightButtonAction: () => void;
}

export const ModalMessage: React.FC<ModalMessageProps> = ({
  title,
  description,
  leftButtonText,
  leftButtonAction,
  rightButtonText,
  rightButtonAction
}) => {
  // Handle ESC key press
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.keyCode === 27) {
        rightButtonAction();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [rightButtonAction]);

  // Handle click outside modal
  const handleOutsideClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.currentTarget.className === 'modal-container') {
      rightButtonAction();
    }
  };

  return (
    <div className="modal-container" onClick={handleOutsideClick}>
      <div
        className="modal"
        role="dialog"
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <div className="modal-header">
          <h2 id="modal-title" className="modal-title">{title}</h2>
          <button
            className="close-button"
            onClick={rightButtonAction}
            aria-label="Fechar"
          >
            &times;
          </button>
        </div>

        <div className="modal-content">
          <p id="modal-description" className="modal-description">{description}</p>
        </div>

        <div className="modal-footer">
          <button
            className="btn left-btn"
            onClick={leftButtonAction}
            autoFocus
          >
            {leftButtonText}
          </button>
          <button
            className="btn right-btn"
            onClick={rightButtonAction}
          >
            {rightButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};
